<sk-checkbox
  stylingMode="unformed"
  data-test="dms-grid-checkbox-header-template"
  [formControl]="valueControl"
  [indeterminate]="indeterminate()"
></sk-checkbox>
